import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=6d986f2d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=6d986f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d986f2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d986f2d')) {
      api.createRecord('6d986f2d', component.options)
    } else {
      api.reload('6d986f2d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=6d986f2d&scoped=true&", function () {
      api.rerender('6d986f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zKtrjj6oLw8J/JS/comp/PopupBox.vue"
export default component.exports